import React from "react";

// import previewMobile from '../assets/images/preview-frame.png';

function PreviewFrame() {
    return(
        <>
        <h4 className="text-center">Preview Frame</h4>
        <div className="preview-inner">
        </div>
      </>
    )
}

export default PreviewFrame;